import { InterfaceLanguages } from '@src/types/language.types'

export const ALL_INTERFACE_LANGUAGES = Object.keys(InterfaceLanguages).map((key) => (InterfaceLanguages as any)[key])

export const DEFAULT_LANGUAGE = InterfaceLanguages.EN
